// WizardStep1.js
import React from 'react';
import MembershipSummaryBanner from './MembershipSummaryBanner';


const MembershipPeriodUnitList = [
  { label: 'Month(s)', value: 'Month' },
  { label: 'Quarter(s)', value: 'Quarter' },
  { label: 'Year(s)', value: 'Year' }
];

const WizardStep1b = ({ formData, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    onChange({ [name]: type === 'checkbox' ? checked : value });
  };


  return (
  <>

      <h4 className="mb-4">Credits</h4>

<MembershipSummaryBanner formData={formData} />





      {/* Reveal the rest only after membershipType is selected */}
      {formData.membershipType && (
        <>



          {formData.membershipType === 3 && (


        <div className="row g-3">
            <div className="col-12">
              <h5 className="mt-4 mb-0">How many credits are granted each period?</h5>
            </div>
            <div className="col-md-4">
              <label>Credits</label>
              <input
                value={formData.perPeriodQtyLimit} type="number" min={1} name="perPeriodQtyLimit"
                onChange={handleChange} 
                className="form-control"
              />
            </div>
        </div>

              )}







        <div className="row g-3">

            <div className="col-12">
              <h5 className="mt-4 mb-0">Will credits ever expire?</h5>
            </div>

            {/* <div className="col-md-4 d-flex align-items-end"> */}
            <div className="col-md-4" style={{margin:'unset'}}>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="membershipItemsNeverExpire"
                    name="membershipItemsNeverExpire"
                    checked={!!formData.membershipItemsNeverExpire}
                    onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="membershipItemsNeverExpire">
                    No
                </label>
            </div>
            </div>

        </div>




          {/* Option Package specific fields */}
          {formData.membershipType === 3 && (
            <>

            <div className="row g-3">

              <div className="col-12">
                <h5 className="mt-4 mb-0">How many unused credits can rollover each period and for how many periods?</h5>
              </div>

              <div className="col-md-4" style={{margin:'unset'}}>
                <label>Rollover Quantity</label>
                <input
                  type="number"
                  name="rollOverQtyLimit"
                  value={formData.rollOverQtyLimit || ''}
                  onChange={(e) => {
                    e.preventDefault();
                    if (e.target.value <= formData.perPeriodQtyLimit) {
                      handleChange(e);
                    } else {
                      handleChange({ target: { name: 'rollOverQtyLimit', value: '' } });
                    }
                  }}
                  className="form-control"
                />
              </div>

              {!formData.membershipItemsNeverExpire && (
                <div className="col-md-4" style={{margin:'unset'}}>
                  <label>Rollover Time Limit</label>
                  <input
                    type="number"
                    name="rollOverTimeLimit"
                    value={formData.rollOverTimeLimit || ''}
                    onChange={(e) => {
                      e.preventDefault();
                      if (e.target.value <= formData.membershipPeriodQty) {
                        handleChange(e);
                      } else {
                        handleChange({ target: { name: 'rollOverTimeLimit', value: '' } });
                      }
                    }}
                    className="form-control"
                  />
                </div>
              )}

            </div>

            </>
          )}
        </>
      )}
























  </>

  );
};

export default WizardStep1b;
